/**
 * Единственный источник правды по картинке превью (og:image).
 *
 * Почему версия зашита в имя файла. Telegram, WhatsApp и LinkedIn кэшируют
 * карточку по URL картинки и не перечитывают её при смене содержимого:
 * ссылка на dnai.engineering три месяца показывала оффер «Цифровые
 * сотрудники для роста маржи», которого на странице давно нет. Перезапись
 * og-image.png этого бы не вылечила — нужен НОВЫЙ адрес. Поэтому при смене
 * оффера поднимается OG_VERSION здесь и в scripts/og/render.mjs, картинка
 * пересобирается (`node scripts/og/render.mjs`), и все мессенджеры видят
 * свежее превью сами, без ручного сброса кэша.
 *
 * Локализованы обе: текст живёт внутри картинки, поэтому русская карточка
 * на /en читается как «превью на чужом языке».
 */
const OG_VERSION = 6

export const OG_IMAGE_RU = `https://dnai.engineering/og-image-v${OG_VERSION}.png`
export const OG_IMAGE_EN = `https://dnai.engineering/og-image-en-v${OG_VERSION}.png`

export const OG_IMAGE_ALT_RU =
  'DNAI Engineering — управляйте бизнесом через ИИ: больше прибыли, скорости и порядка. Внедрение за 2–3 месяца, 65 проектов в 33 нишах.'
export const OG_IMAGE_ALT_EN =
  'DNAI Engineering — run your business through AI: more profit, speed and order. Rollout in 2–3 months, 65 projects across 33 industries.'
